import React from "react";
import {
  CruiseSectionShipFragment,
  CruiseSectionShipVersionFragment
} from "types/graphql-types";
import { arrayIsNotEmpty, isPresent } from "src/utils/checks";
import ShipDiningAreas from "./ShipDiningAreas";
import ShipDiningAreasRows from "./ShipDiningAreasRows";
import ShipPublicAreas from "./ShipPublicAreas";
import ShipIntro from "./ShipIntro";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";

type CruiseSectionShipProps = {
  ship: CruiseSectionShipFragment;
  shipVersion: CruiseSectionShipVersionFragment;
  ecommerceStatus?: ECommerceStatus;
};

const CruiseSectionShip: React.FC<
  React.PropsWithChildren<CruiseSectionShipProps>
> = ({ ship, shipVersion, ecommerceStatus }) => {
  if (!shipVersion) throw `No current version for ship ${ship.name}`;

  const diningAreas = shipVersion.diningAreas?.filter(isPresent);
  const facilities = shipVersion.facilities?.filter(isPresent);

  return (
    <React.Fragment>
      <ShipIntro
        ship={ship}
        shipVersion={shipVersion}
        ecommerceStatus={ecommerceStatus}
      />

      {arrayIsNotEmpty(diningAreas) && (
        <ShipDiningAreas
          diningAreas={diningAreas}
          shipName={ship.name!}
          backgroundColor="neutral05"
        >
          <ShipDiningAreasRows diningAreas={diningAreas} />
        </ShipDiningAreas>
      )}
      {arrayIsNotEmpty(facilities) && (
        <ShipPublicAreas facilities={facilities} />
      )}
    </React.Fragment>
  );
};

export default React.memo(CruiseSectionShip);
